module.exports = __webpack_public_path__ + "static/media/C3.b0c1110b.png";